import { useToast } from '@zenterprise-inc/ui';
import { useState } from 'react';

export type PasswordErrorType = 'NONE' | 'EMPTY' | 'MIN_LENGTH' | 'INVALID' | 'UNKNOWN';

export const MINIMUM = 6;

export const usePasswordError = () => {
  const [passwordError, setPasswordError] = useState<PasswordErrorType>('NONE');
  const toast = useToast();

  const resetPasswordError = () => {
    setPasswordError('NONE');
  };

  const invalidPasswordError = () => {
    setPasswordError('INVALID');
  };

  const inputPasswordError = (password: string) => {
    if (!password) {
      setPasswordError('EMPTY');
    } else if (password.length < MINIMUM) {
      setPasswordError('MIN_LENGTH');
    }
  };

  const unknownErrorToast = () => {
    toast({
      content: '일시적인 오류가 발생했어요. 잠시 후 다시 시도해주세요.',
      icon: 'error',
      iconColor: 'red.600'
    });
  };

  return {
    passwordError,
    setPasswordError,
    resetPasswordError,
    invalidPasswordError,
    inputPasswordError,
    unknownErrorToast
  };
};
